import React, { forwardRef } from 'react';

import './EditPanelButton.css';

const EditPanelButton = forwardRef<
  HTMLButtonElement,
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>
>(({ children, onClick, className = '', disabled, ...props }, ref) => (
  <button {...props} ref={ref} onClick={onClick} disabled={disabled} className={`EditPanelButton ${className}`}>
    {children}
  </button>
));

EditPanelButton.displayName = 'EditPanelButton';

export default EditPanelButton;
